module.exports = __webpack_public_path__ + "img/demo.4d735e2f.jpg";